export const SET_BUSINESS_EVENTS = 'SET_BUSINESS_EVENTS';
export const SET_OFFERS_ELIGIBILITY = 'SET_OFFERS_ELIGIBILITY';
export const SET_OFFERS_ELIGIBILITY_FETCHED = 'SET_OFFERS_ELIGIBILITY_FETCHED';
